import Appointment from '@spike/appointment-model';
import { Moment } from 'moment-timezone';
import {
    BusinessAreaType,
    FixedPriceOption,
    Service,
    SERVICES_BUSINESS_AREAS,
    ServiceDuration,
    ServicePricing,
    VariableDuration,
    VariablePriceOption
} from 'model/Service';

export const checkServiceDuration = (
    duration: ServiceDuration,
    petType: string | undefined,
    petSize: string | undefined
) => {
    let durationResult = 0;
    let hour = 0;
    let min = 0;
    let minArray = [];

    if (petType !== undefined) {
        if (duration.simple) {
            hour = duration.simple!.hours * 60;
            min = duration.simple!.minutes + hour;
        } else {
            minArray = duration.variable!.filter((pet: VariableDuration) => pet.petSize.id === petSize?.toLowerCase());

            if (minArray.length > 0) {
                hour = minArray[0].duration.hours * 60;
                min = minArray[0].duration.minutes + hour;
            }
        }
    } else {
        if (duration.simple) {
            hour = duration.simple!.hours * 60;
            min = duration.simple!.minutes + hour;
        }
    }
    durationResult = min as number;
    return durationResult;
};

export const convertToHoursAndMinutes = (totalDurationInMinutes: number): string => {
    const hours = Math.trunc(totalDurationInMinutes / 60);
    const minutes = totalDurationInMinutes % 60;

    return `${hours}.${minutes}`;
};

export const checkServicePrice = (
    pricing: ServicePricing,
    petType: string | undefined,
    petSize: string | undefined,
    petHair: string | undefined,
    petHairLength?: string | undefined
) => {
    let priceResult = 0;

    if (petType !== undefined) {
        if (pricing.fixedPrice.length > 0) {
            let prices: Array<FixedPriceOption> = [];
            prices = pricing.fixedPrice.filter((pet: FixedPriceOption) => pet.petType.singular === petType);
            prices?.length > 0 ? (priceResult = prices[0]!.price!) : (priceResult = 0);
        } else {
            let arrayPrice: Array<VariablePriceOption> = [];

            if (pricing.variablePrice?.prices !== undefined) {
                arrayPrice = pricing.variablePrice?.prices;

                // filter price by hair length
                if (petHairLength !== undefined) {
                    if (pricing.variablePrice!.variables.hairLengthVariable) {
                        arrayPrice = arrayPrice?.filter(
                            (price: VariablePriceOption) => price.hairLength?.id === petHairLength
                        );
                    }
                }

                // filter price by hair
                if (pricing.variablePrice!.variables.hairTypeVariable) {
                    arrayPrice = arrayPrice?.filter((price: VariablePriceOption) => price.hairType?.name === petHair);
                }

                // filter price by pet size
                if (pricing.variablePrice!.variables.petSizeVariable) {
                    arrayPrice = arrayPrice?.filter((price: VariablePriceOption) => price.petSize?.id === petSize);
                }

                // filter price by pet type
                if (pricing.variablePrice!.variables.petTypeVariable) {
                    arrayPrice = arrayPrice?.filter(
                        (price: VariablePriceOption) => price.petType?.singular === petType
                    );
                }
            }

            if (arrayPrice?.length > 0) {
                priceResult = arrayPrice[0]!.price!;
            } else {
                priceResult = 0;
            }
        }
    } else {
        // Si no tiene datos del Pet el precio devuelve 0
        priceResult = 0;
    }

    return priceResult;
};

export const checkServicePetSize = (service: Service, petType: string | undefined, petSize: string | undefined) => {
    let servicePetSize = true;

    if (service.pricing.fixedPrice.length > 0 || petType === undefined) {
        servicePetSize = true;
    } else {
        let prices: Array<VariablePriceOption> = [];

        if (service.pricing.variablePrice !== undefined) {
            prices = service.pricing.variablePrice!.prices.filter(
                (pet: VariablePriceOption) => pet.petType?.singular === petType
            );
            if (prices.find(price => price.petSize === undefined) === undefined) {
                prices = service.pricing.variablePrice!.prices.filter(
                    (pet: VariablePriceOption) => pet.petType?.singular === petType && pet.petSize?.id === petSize
                );
            }

            if (service.duration.simple == undefined) {
                const petSizes: Array<string> = service.duration.variable.map(d => d.petSize.id);
                if (!(petSize && petSizes.includes(petSize)) && petSizes.length > 0) {
                    servicePetSize = false;
                }
            }
        }

        if (prices.length === 0) {
            servicePetSize = false;
        }
    }

    return servicePetSize;
};

export const appointmentMatchesBusinessArea = (appointment: Appointment, businessArea: BusinessAreaType): boolean => {
    if (businessArea === SERVICES_BUSINESS_AREAS.GROOMING) {
        return appointment.services.some(
            service =>
                service.businessArea?.id === SERVICES_BUSINESS_AREAS.GROOMING ||
                service.businessArea?.id === SERVICES_BUSINESS_AREAS.DENTAL
        );
    }

    return appointment.services.some(service => service.businessArea?.id === businessArea);
};

export const hasSameDayDuplicateInBusinessArea = (
    appointmentId: number,
    targetAt: Moment,
    businessArea: BusinessAreaType,
    appointments: Array<Appointment>,
    timeZone: string
): boolean => {
    const sourceAppointment = appointments.find(appointment => appointment.id === appointmentId);
    if (!sourceAppointment) {
        return false;
    }

    const targetDay = targetAt.clone().tz(timeZone);

    return appointments.some(appointment => {
        if (appointment.id === sourceAppointment.id) {
            return false;
        }

        if (appointment.pet.id !== sourceAppointment.pet.id) {
            return false;
        }

        if (!appointmentMatchesBusinessArea(appointment, businessArea)) {
            return false;
        }

        return appointment.duration.from.clone().tz(timeZone).isSame(targetDay, 'day');
    });
};
